import { render } from "./PimProductsOverviewCriteria.vue?vue&type=template&id=14bd55d0&scoped=true&ts=true"
import script from "./PimProductsOverviewCriteria.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverviewCriteria.vue?vue&type=script&lang=ts"

import "./PimProductsOverviewCriteria.vue?vue&type=style&index=0&id=14bd55d0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bd55d0"]])

export default __exports__